/**
 * Shared types for Post Shift Feedback feature
 *
 * Allows employees to provide feedback after completing a shift,
 * including break compliance and shift satisfaction.
 */
import { z } from "zod";
// ===== ENUMS =====
export const BreakMissedReasonSchema = z.enum([
    "TOO_BUSY",
    "MANAGER_REQUESTED",
    "VOLUNTARY",
    "OTHER",
]);
// ===== INPUT SCHEMAS =====
/**
 * Create post-shift feedback input
 */
export const CreatePostShiftFeedbackInputSchema = z.object({
    tookFullBreak: z.boolean(),
    breakMissedReason: BreakMissedReasonSchema.nullable(),
    shiftSatisfaction: z.number().int().min(1).max(4).optional(),
    comment: z.string().max(250).optional(),
});
/**
 * Update post-shift feedback input (all fields optional)
 */
export const UpdatePostShiftFeedbackInputSchema = z.object({
    tookFullBreak: z.boolean().optional(),
    breakMissedReason: BreakMissedReasonSchema.nullable().optional(),
    shiftSatisfaction: z.number().int().min(1).max(4).optional(),
    comment: z.string().max(250).optional(),
});
// ===== RESPONSE SCHEMAS =====
/**
 * Post-shift feedback response schema
 */
export const PostShiftFeedbackResponseSchema = z.object({
    id: z.uuid(),
    tookFullBreak: z.boolean(),
    breakMissedReason: BreakMissedReasonSchema.nullable(),
    shiftSatisfaction: z.number().int().nullable(),
    comment: z.string().nullable(),
    shiftId: z.uuid(),
    companyId: z.uuid(),
    userId: z.uuid(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
